import React from 'react';

// Defining these gradients in their own svg, for use in fill styles in other components

const SvgGlobals = () => (
  <svg style={{ width: 0, height: 0, position: 'absolute' }} aria-hidden focusable={false}>
    <linearGradient id="averageRankingGradient" x2="1" y2="1">
      <stop offset="14%" stopColor="#a51604" />
      <stop offset="83%" stopColor="#e51e06" />
    </linearGradient>
    <linearGradient id="rankingGradient" x2="1" y2="1">
      <stop offset="10%" stopColor="#636e8e" />
      <stop offset="70%" stopColor="#d4dae9" />
    </linearGradient>
  </svg>
);

export default SvgGlobals;
